export const TOURIST_ROUTES_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'province',
    label: 'Provincia',
  },
  {
    field: 'kms',
    label: 'Km.',
    classObj: ['query__header--align-right'],
  },
  {
    field: 'itinerary',
    label: 'Recorrido',
  },
];
